module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "pix"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageix",
      "title": "ix"
    }
  }, [_c('a', {
    attrs: {
      "id": "list"
    }
  }), _vm._v("List of illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Proclamation issued at the height of the disturbances, 1847")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("In famine times, children were often said to be ‘in rags’")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A house of the sort seen throughout the Hebrides at the time")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Irish famine victims, West Cork")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("The lodge by Loch Laggan")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Fishing boats in Pulteneytown Harbour, Wick")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A procession in Pulteneytown’s Union Street")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Bridge Street, Wick, the scene of repeated protests")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Inverness Town Hall")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Herring gutters at work")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Homes of the type occupied by many of the rioters")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A street scene in Cromarty, where people protested at the soaring food prices")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Rhynie Farm, Easter Ross")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Findhorn Harbour")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A Lossiemouth fishwife")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("The grain storehouse at Foulis Point, near Dingwall")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Hopeman was home to many of those involved in the Burghead riots")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18948ca1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/list.vue
// module id = 72
// module chunks = 0